import React from 'react';

import {
  Alert,
  AlertDescription,
  AlertTitle,
  AlertIcon,
  Flex,
} from '@frontend/components';

class NotificationErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <Alert status="error">
          <AlertIcon />
          <Flex w="100%" direction="column">
            <AlertTitle>Unable to display notification</AlertTitle>
            <AlertDescription>
              We encountered a fatal error. Please contact support
            </AlertDescription>
          </Flex>
        </Alert>
      );
    }
    return this.props.children;
  }
}

export default NotificationErrorBoundary;
